import {
  Component,
  inject,
  OnInit,
  ChangeDetectorRef,
  Inject,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TableConfiguration } from "../../../../shared/components/paginated-data-table/paginated-table-configuration.model";

interface WarehouseStability {
  warehouse_name: string;
  humidity_stability: number;
  summary: {
    total_readings: number;
    stable_humidity_readings: number;
    out_of_range_humidity_readings: number;
  };
}

interface HumidityStabilityModalData {
  stability: any; 
  warehouseUniqueId?: string;
}
@Component({
  selector: "app-humidity-stability-modal",
  templateUrl: "./humidity-stability-modal.component.html",
  styleUrl: "./humidity-stability-modal.component.scss",
})
export class HumidityStabilityModalComponent implements OnInit {

  private dialogRef = inject(MatDialogRef<HumidityStabilityModalComponent>);
  private cdr = inject(ChangeDetectorRef);

constructor(@Inject(MAT_DIALOG_DATA) private data: HumidityStabilityModalData) {}

  title: string = "Humidity Stability";
  loading: boolean = true;
  refreshDataTable: boolean = false;


  tableData: WarehouseStability[] = [];


  calculationMethod: any = null;
  interpretation: any = null;

  activeTab: "summary" | "table" = "summary";

  setTab(tab: "summary" | "table") {
    this.activeTab = tab;
  }

  tableConfiguration: TableConfiguration = {
    tableColumns: [
      { name: "warehouse_name", label: "Warehouse" },
      { name: "humidity_stability", label: "Humidity Stability (%)" },
    ],
    showNumbers: true,
    showSearch: true,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    empty_msg: "No data found",
    deleting: {},
    active: {}
  };

  ngOnInit(): void {

    const fullData = this.data?.stability;

    if (fullData) {
      this.calculationMethod = fullData?.calculation_method;
      this.interpretation = fullData?.interpretation;

    
      this.tableData = fullData?.warehouses ?? [];
    }

    this.loading = false;
    this.tableConfiguration.doneLoading = true;
    this.cdr.detectChanges();
  }

  closeModal() {
    this.dialogRef.close();
  }
}